import type { CorvidSDKPropsFactory } from '@wix/editor-elements-types/corvid';
import { withValidation } from '../../validations';

import type { AriaAttributesSDKProps, AriaAtomicSDK } from './types';
import { assert } from '../../assert';

const atomicSDKFactory: CorvidSDKPropsFactory<
  AriaAttributesSDKProps,
  AriaAtomicSDK
> = ({ setProps, props }) => ({
  get atomic() {
    return props.ariaAttributes?.atomic;
  },

  set atomic(value) {
    setProps({
      ariaAttributes: {
        ...props.ariaAttributes,
        atomic: assert.isNil(value) ? undefined : String(value),
      },
    });
  },
});

export const createAtomicSDK = withValidation(atomicSDKFactory, {
  type: ['object'],
  properties: {
    atomic: {
      type: ['boolean', 'string'],
      enum: ['false', 'true'],
    },
  },
});
